import React from "react";
import { Link, withRouter } from "react-router-dom";

const Columns = (addUpd, destroy, changePassword) => {
  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      id: "email",
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      id: "profile",
      name: "Perfil",
      selector: (row) => row.profile_name,
    },
    {
      id: "company_id",
      name: "Empresa",
      selector: (row) => row.company_name,
    },
    {
      id: "actions",
      name: "Acciones",
      button: true,
      width: "200px",
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar usuario"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>

          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Cambiar contraseña"
              onClick={() => changePassword(row)}
            >
              <i className="fas fas fa-user-lock"></i>
            </button>
          </div>

          <div className="p-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar usuario"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>

          <div className="p-2 d-none">
            <Link
              to={`/users/profile/${row.id}`}
              className="btn btn-info btn-sm"
              title="Perfil de usuario"
            >
              <i className="fa fa-address-book"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  return columns;
};

export default Columns;
